import { getApi, postApi } from '../../utils/api'

export function createBuilding(data) {
  return postApi({
    data,
    endpoint: `idwell-api/api/v3/construction/buildings/`,
  })
}

export function getBuildings(search, params) {
  return getApi({
    endpoint: 'idwell-api/api/v3/construction/building-options/',
    params: {
      ...(search ? { search } : null),
      ...params,
    },
  })
}
